import * as Sentry from '@sentry/react'

import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { AppController } from './App.controller'
import { AppHeaderSwitchProvider } from '../AppHeaderSwitch'
import { AppMetaProvider } from './appMeta.context'
import { AppStyleSwitchProvider } from '../AppStyleSwitch'
import { BrowserRouter } from 'react-router-dom'
import { FeatureFlagProvider } from 'utils/featureFlags'
import GlobalContextProvider from '../ContextProviders/GlobalContextProvider'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import moment from 'moment-timezone'
import { markAppReady } from 'utils/analytics/appReady'
import { queryClient } from 'utils/reactQuery'

const AppModule: FC = () => {

  const { i18n } = useTranslation()

  // The app tree's first commit, which replaced the boot loader in index.html.
  useEffect(() => {
    markAppReady()
  }, [])

  return (
    <FeatureFlagProvider>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <GlobalContextProvider>
            <AppMetaProvider>
              <AppStyleSwitchProvider>
                <AppHeaderSwitchProvider>
                  <LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment} adapterLocale={i18n.language}>

                    {process.env.NODE_ENV !== 'production' &&
                      <ReactQueryDevtools initialIsOpen={false} />
                    }

                    <AppController />

                  </LocalizationProvider>
                </AppHeaderSwitchProvider>
              </AppStyleSwitchProvider>
            </AppMetaProvider>
          </GlobalContextProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </FeatureFlagProvider>
  )
}

export const App = Sentry.withProfiler(AppModule)
